import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Slough() {
  return <CityManagementPage config={allCityConfigs.slough} />;
}